<template>
<div class="maintenance-record">
    <div :class="{'bg-head-nav': true}"></div>
    <div class="main-content-full">
        <div class="table-container">
            <el-table :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="em_num" label="订单号" align="center" min-width="25%">
                </el-table-column>
                <el-table-column prop="create_time" label="日期" align="center" min-width="25%">
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="25%">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="findOrderDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="check_user_name" label="审核状态" align="center" min-width="25%">
                    <template slot-scope="scope">
                        <span v-if="scope.row.em_revoke == false && scope.row.em_status == false">未审核</span>
                        <span v-if="scope.row.em_revoke == true">已驳回审核</span>
                        <span v-if="scope.row.em_revoke == false && scope.row.em_status == true">已审核</span>
                    </template>
                </el-table-column>
                
            </el-table>
        </div>
    </div>
    <div class="dialog-group">
        <el-dialog title="保养详情" :visible.sync="centerDialogVisible" width="703px" center>
            <div class="maintenance-base-inifo">
                <div class="person-info">
                    保养师名称：<span  class="maintenance-name">{{currentRecordObj.em_user}}</span>
                    车主姓名：<span  class="car-user-name">{{car_host_name}}</span>
                </div>
                <div class="date-time">日期：<span  class="date-time-value">{{currentRecordObj.create_time}}</span></div>
            </div>
            <div class="maintenance-content">
                <div class="maintenance-content-title">保养内容：</div>
                <div class="maintenance-content-main">
                    <div v-for="(item, index) in currentRecordObj.megood" :key="index" class="maintenance-content-item clearfix">
                        <div class="maintenance-content-item-left">
                            <img  :src="item.good_picture" alt="" class="product-img">
                        </div>
                        <div class="maintenance-content-item-right">
                            <div class="product-name">{{item.good_name}}</div>
                            <div class="product-num">选购数量: &nbsp;{{item.number}}</div>
                            <div class="product-price">单品价格: &nbsp;￥{{item.price}}</div>
                            <div class="product-single-price">单品合计: &nbsp;￥{{item.total_price}}</div>
                        </div>
                    </div>
                    <div class="product-all-price">订单合计：<span  class="order-all-price">{{currentRecordObj.total_price}}</span></div>
                </div>
            </div>
            <div class="comment-detail">
                <div class="comment-star-container">
                    <div class="comment-star-container-text">评价详情：</div>
                    <el-rate class="comment-star-container-star" v-model="currentComment.evaluate_grade" disabled show-score text-color="#ff9900" score-template="{value}星">
                    </el-rate>
                </div>
                <div class="comment-text-container">{{currentComment.evaluate_content}}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="currentRecordObj.check_user_id == user.id" type="primary" @click="checkOk">确认审核</el-button>
                <el-button v-else @click="showTipMsg" type="primary">确认审核</el-button>
                <el-button v-if="currentRecordObj.check_user_id == user.id" @click="rejeckCheck">驳回审核</el-button>
                <el-button v-else @click="showTipMsg">驳回审核</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            starLevel: 4,
            tableData: [],
            currentRecordObj: {},
            car_host_name: '',
            currentComment: {},
            centerDialogVisible: false
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    created() {
        this.axios.get('electronic_maintenance', {
                params: {
                    user_id: this.user.id
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            return 'color: #000;'
        },
        findOrderDetail(rowData) {
            this.currentRecordObj = rowData;
            this.car_host_name = this.currentRecordObj.host_info.car_host_name;
            console.log(this.car_host_name)
            this.axios.get('get_evaluate', {
                    params: {
                        em_id: rowData.id
                    }
                })
                .then(res => {
                    this.currentComment = res.data.data;
                    this.centerDialogVisible = true;
                })
        },
        // 确认审核
        checkOk() {
            if(this.currentRecordObj.em_revoke) {
                this.$message({
                    type: 'warning',
                    message: '已驳回审核！'
                })
                return;
            }
            else if(this.currentRecordObj.em_status){
                this.$message({
                    type: 'warning',
                    message: '已审核！'
                })
                return;
            }
            this.axios.get('checkem', {
                params: {
                    em_id: this.currentRecordObj.id
                }
            })
            .then(res => {
                if(res.data.status == 1) {
                    this.$message({
                        'type': 'success',
                        'message': res.data.msg
                    })
                    // 暂时给用户发钱的活动停止，此代码没用了，再有类似的活动，把次代码解开
                    // setTimeout(() => {
                    //     this.axios.get('check_sendmoney', {
                    //         params: {
                    //             em_id: this.currentRecordObj.id
                    //         }
                    //     })
                    //     .then(res => {
                    //         var randomNum = res.data.random_num;
                    //         // alert(this.MD5(randomNum+'15201193149'));
                    //         this.axios.get('send_money', {
                    //             params: {
                    //                 em_id: this.currentRecordObj.id,
                    //                 secret_key: this.MD5(randomNum+'15201193149')
                    //             }
                    //         })
                    //         .then(res => {
                    //             if(res.data.status == 2) {
                    //                 this.$message({
                    //                     type: 'error',
                    //                     message: res.data.msg
                    //                 })
                    //                 this.centerDialogVisible = false;
                    //             }
                    //             else {
                    //                 this.$message({
                    //                     type: 'success',
                    //                     message: res.data.msg
                    //                 })
                    //                 this.centerDialogVisible = false;
                    //             }
                    //         })
                    //     })
                    // }, 3700)
                }
            })
        },
        // 驳回审核
        rejeckCheck() {
            if(this.currentRecordObj.em_revoke) {
                this.$message({
                    type: 'warning',
                    message: '已驳回审核！'
                })
                return;
            }
            else if(this.currentRecordObj.em_status){
                this.$message({
                    type: 'warning',
                    message: '已审核！'
                })
                return;
            }
            this.axios.get('revokeem', {
                params: {
                    em_id: this.currentRecordObj.id
                }
            })
            .then(res => {
                this.$message({
                    type: 'success',
                    message: res.data.msg
                })
            })
        },
        showTipMsg() {
            this.$message({
                type: "error",
                message: '非法的操作！'
            })
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.bg-head-nav {
    background-color: #d2f5e8;
    height: 12px;
}

.maintenance-base-inifo {
    line-height: 76px;
    color: #2e2e2e;
    font-family: PingFangSC-Regular;
}

.maintenance-base-inifo>div {
    display: inline-block;
    font-size: 16px;
}

.car-user-name {
    margin-right: 10px;
}

.date-time {
    color: #686868;
    font-family: PingFangSC-Regular;
}

.maintenance-content-title {
    font-size: 18px;
    font-family: PingFangSC-Regular;
    color: #2e2e2e;
    text-align: left;
    margin-bottom: 5px;
}

.maintenance-content-main {
    height: 124px;
    overflow-y: scroll;
    padding: 8px;
}

.maintenance-content-item {
    background-color: #f4f4f4;
}

.maintenance-content-item-left {
    float: left;
    width: 132px;
    height: 130px;
}

.product-img {
    width: 132px;
    height: 130px;
}

.maintenance-content-item-right {
    float: left;
    width: 470px;
    padding-left: 10px;
    margin-left: 5px;
    color: #686868;
    font-size: 14px;
    line-height: 30px;
}

.product-all-price {
    text-align: right;
    font-size: 16px;
    color: #2e2e2e;
    line-height: 36px;
}

.order-all-price {
    color: #ff2734;
}

.comment-star-container {
    margin-top: 10px;
    margin-bottom: 10px;
}

.comment-star-container-text {
    display: inline-block;
    font-size: 16px;
    color: #2e2e2e;
    margin-right: 14px;
}

.comment-star-container-star {
    display: inline-block;
    position: relative;
    top: -2px;
}

.comment-text-container {
    width: 615px;
    height: 94px;
    font-size: 14px;
    color: #3d3d3d;
    font-family: PingFangSC-Regular;
    margin: 0 auto;
    background-color: pink;
    border: 1px dashed #888;
    border-radius: 6px;
    padding: 10px 20px;
    overflow-y: scroll;
    background-color: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/MaintainRecord.vue